import React, { useMemo } from "react";

import { Button, Popover, Typography } from "@material-ui/core";

import { MdKeyboardArrowDown } from "react-icons/md";

import { usePopupState } from "modules/core/hooks/usePopupState";
import { useRollupsQuery } from "modules/projects/hooks/queries/useRollupsQuery";
import { useStyles } from "./useStyles";

import { getOptionsFromData, RollupsItemType } from "../RollupsList/helpers";

import RollupsList, { typeIconsMap } from "../RollupsList";

interface IProjectSelectProps {
  value: string;
  onChange: (rollupId: string | "all", rollupsType: RollupsItemType) => void;
  disabled?: boolean;
  disableListCache?: boolean;
}

const RollupsSelect: React.FC<IProjectSelectProps> = props => {
  const { value, onChange, disabled, disableListCache } = props;

  const { data: rollupsData } = useRollupsQuery({
    disableCache: disableListCache
  });

  const { anchorEl, isOpen, handleOpen, handleClose } = usePopupState();

  const options = useMemo(() => {
    return rollupsData ? getOptionsFromData({ data: rollupsData }) : [];
  }, [rollupsData]);

  const selectedOption = useMemo(() => {
    return options.find(option => option.value === value) || null;
  }, [options, value]);

  const classes = useStyles({
    selectedType: selectedOption?.type
  });

  return (
    <>
      <Button
        fullWidth
        startIcon={selectedOption ? typeIconsMap[selectedOption.type] : null}
        endIcon={<MdKeyboardArrowDown size={18} />}
        onClick={handleOpen}
        disabled={disabled}
        title={selectedOption?.label}
        variant="outlined"
        color="default"
        size="small"
        classes={{
          root: classes.triggerbutton,
          label: classes.triggerLabel,
          startIcon: classes.triggerStartIcon,
          endIcon: classes.triggerEndIcon
        }}
      >
        <Typography component="span" variant="caption" noWrap>
          {selectedOption?.label}
        </Typography>
      </Button>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        disableScrollLock
        transitionDuration={{ exit: 0, enter: 0 }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        classes={{ paper: classes.popover }}
      >
        <RollupsList
          data={rollupsData}
          options={options}
          onChange={onChange}
          onClose={handleClose}
          value={selectedOption}
        />
      </Popover>
    </>
  );
};

export default React.memo(RollupsSelect);
